import request from '@/api/req/request'




/** 是否有发布简历权限*/
export function isPermissionApi() {
    return request({
        url: '/index/V2.ScreenResumes/isPermission',
        method: 'POST'
    })
}

/** 发布筛选*/
export function creationResumeApi(data) {
    return request({
        url: '/index/V2.ScreenResumes/creationResume',
        method: 'POST',
        data
    })
}

/** 发布筛选*/
export function searchJobNumberApi(keywords) {
    return request({
        url: '/index/V2.ScreenResumes/searchJobNumber',
        method: 'POST',
        data: {
            keywords
        }
    })
}

//简历列表
export function resumeListApi(data) {
    return request({
        url: '/index/V2.ScreenResumes/resumeList',
        method: 'POST',
        data
    })
}



/**简历任务详情*/
export function resumeTaskDetailsApi(task_id) {
    return request({
        url: '/index/V2.ScreenResumes/resumeTaskDetails',
        method: 'POST',
        data: {
            task_id
        }
    })
}

/**简历评价详情*/
export function resumeProjectApi(task_id) {
    return request({
        url: '/index/V2.ScreenResumes/resumeProject',
        method: 'POST',
        data: {
            task_id
        }
    })
}

/**提交评估表  简历评审阶段*/
export function writeResumeRelsultApi(data) {
    return request({
        url: '/index/V2.ScreenResumes/writeResumeRelsult',
        method: 'POST',
        data
    })
}
/**提交评估表  面试评审阶段*/
export function writeInterviewRelsultApi(data) {
    return request({
        url: '/index/V2.ScreenResumes/writeInterviewRelsult',
        method: 'POST',
        data
    })
}

/**单条简历筛选评价详情*/
export function evaluateDetailsApi(eva_id) {
    return request({
        url: '/index/V2.ScreenResumes/evaluateDetails',
        method: 'POST',
        data: {
            eva_id
        }
    })
}

/**单条简历筛选评价详情*/
export function interviewDetailsApi(eva_id) {
    return request({
        url: '/index/V2.ScreenResumes/interviewDetails',
        method: 'POST',
        data: {
            eva_id
        }
    })
}



/**提交（发布）面试信息*/
export function issueInterviewApi(data) {
    return request({
        url: '/index/V2.ScreenResumes/issueInterview',
        method: 'POST',
        data
    })
}


